























































import {Vue, Component} from 'vue-property-decorator';
import {DisplayEnum} from '@/types/enum';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {toI18n} from '@/utils/commonUtils';

@Component({
  components: {
    PageFormSelect
  }
})
export default class ModifySalePrice extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private get mallProductNos(): string[] {
    return this.$route.params.mallProductNos.split(',');
  }

  private isError = false;

  private priceMaxLength = 11;
  private priceValue = '';
  private currentPriceType = 'AMOUNT';
  private currentModifyType = this.mallProductNos.length > 1 ? 'INCREASE' : 'UPDATE';

  private priceType: DisplayEnum[] = [
    {value: 'AMOUNT', label: this.toI18n('WON')},
    {value: 'PERCENT', label: '%'}
  ];

  private modifyType: DisplayEnum[] = [
    {value: 'INCREASE', label: this.toI18n('IMPRESSION')}, //인상
    {value: 'DECREASE', label: this.toI18n('CUT')}, //인하
    {value: 'UPDATE', label: this.toI18n('CHANGE_TO')} //으로 변경
  ];

  private priceInputEvent() {
    if (/[^\d\,]+/g.test(this.priceValue)) {
      this.isError = true;
    } else {
      this.isError = false;
    }
    const str = this.priceValue.replace(/[^0-9]/g, '');
    const number = str.replace(/^0+/, '');
    if (this.priceMaxLength === 11) {
      this.priceValue = number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      this.priceValue = number;
    }
  }

  private priceInputBlur() {
    this.isError = false;
    const str = this.priceValue.replace(/[^0-9]/g, '');
    if (str.length && this.priceMaxLength === 11) {
      if (Number(str) % 10 > 0) {
        alert(this.toI18n('PRICE_IN_UNITS_OF_10_WON')); //가격은 10원 단위로 입력 가능합니다
      }
    }
  }

  private onChangePriceType() {
    this.priceValue = '';
    if (this.currentPriceType === 'PERCENT') {
      this.priceMaxLength = 2;
    } else {
      this.priceMaxLength = 11;
    }
  }

  private save() {
    const priceValue = this.priceValue.replace(/[^0-9]/g, '');
    if (!priceValue.length) {
      alert(this.toI18n('PLEASE_ENTER_A_VALUE')); //값을 입력해주세요
      return;
    }

    const data = {
      adjustmentUnit: this.currentPriceType,
      amount: Number(priceValue),
      adjustmentType: this.currentModifyType,
      productNos: this.mallProductNos as any
    };

    this.$api.putProductsSalePrice({data}).then(({data}: any) => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      window.opener.postMessage({modifySalePrice: true, data});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup', 'popup_medium');

    if (this.mallProductNos.length === 1) {
      const params = {
        mallProductNo: Number(this.mallProductNos[0])
      };
      this.$api.getProductByNo({params}).then(({data: {salePrice}}: any) => {
        this.priceValue = String(salePrice).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      });
    }

    window.name = 'salePrice';
  }
}
